import React from "react";
import Loader from "../LoadScreen/Loader";
import { Paper, Typography, Box } from "@mui/material";

export default function DownloadDialog({ open, progress, layer }) {
  return (
    <>
      {open && (
        <Box disableEscapeKeyDown disableBackdropClick>
          <Paper
            sx={{
              position: "absolute",
              top: "50%",
              left: "40%",
              p: 2,
              zIndex: 100,
              width: "20rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body" fontSize={16} lineHeight={1.5} mb={2}>
              Downloading the dataset for '{layer.name}'.
            </Typography>
            <Typography variant="body" fontSize={16} lineHeight={1.5} mb={2}>
              Please wait...
            </Typography>
            {progress && (
              <Loader size={50} thickness={5}>
                <Typography sx={{ mt: 2 }}>{progress}</Typography>
              </Loader>
            )}
          </Paper>
        </Box>
      )}
    </>
  );
}
